import { useQuery, gql, type QueryResult, useApolloClient } from '@apollo/react-hooks';
import { getAttachment as ge, getUser } from '#/graphql/queries';
import type { GetAttachmentQuery } from '#/graphql/types';
import { useCallback } from 'react';

const q = gql(ge);

const useAttachmentQuery = () => {
  const client = useApolloClient();

  const getAttachment = useCallback((id: string) => client.query<GetAttachmentQuery>({
    query: q,
    variables: { id },
  }),[]);
  return { getAttachment };
};

export default useAttachmentQuery;